import isNil from "lodash.isnil";
import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Button, Col, Container, Label, Row, TabPane } from "reactstrap";
import QuotationTable, {
  FIRST_MONTH,
  LAST_MONTH,
  TODAY_NUMBER_MONTH
} from "../../../../Quotations/components/QuotationTable";
import { Filters, QuotationInterface } from "../../../../Quotations/types";
import { getEmptyFilters } from "../../../../Quotations/utils";
import ModalFrame from "../../../../toolkit/modalFrame";
import { Club } from "../../../../types-business/Clubs";
import IAction from "../../../../types/IAction";
import { userHasPermission } from "../../../../utils/accessTree";
import {
  PARTNER_MEMB_ACTIVE_STATUS,
  PARTNER_MEMB_INACTIVE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS
} from "../../../../utils/constants";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  infoNotification,
  successNotification,
  UPDATE_CONVENIO_INFO,
  UPDATE_CONVENIO_SUCCESS
} from "../../../../utils/notifications";
import permissionCodes from "../../../../utils/permissionCodes";
import {
  switchMembershipRequest,
  switchMembershipValidationRequest,
  updateConvenioRequest
} from "../../../actions/partners";
import { Partner } from "./../interfaces";
import NotificationsMessages from "./../notificationsMessages";
import ProcedureChargesMessages from "./../procedureChargesMessages";
import s from "./../tabStyles.scss";
import TransferClubMembership from "./../transferClub";
import ActivatePresaleMembreship from "./activatePresaleMmbership";
import CambioTitular from "./cambioTitular";
import CancelMembership from "./cancelacionMembresia/cancelMembership";
import CesionDerechos from "./cesionDerechos";
import CambiarPagoMensual from "./changeToMonthlyPayment";
import InactivarMembresia from "./inactivarMembresia";
import PreviousMaintenanceChange from "./previousMaintenanceChange";
import DirectMaintenanceChange from "./directMaintenanceChange";
import DirectMembershipChange from "./directMembershipChange";
import RecotizarMembresia from "./recotizarMembresia";
import { QuotationNoMembership } from "../../../../Quotations/components/QuotationNoMembership";

interface Props {
  partner: Partner;
  quotations: QuotationInterface;
  clubs: Club[];
  match: any;
  history: any;
  agreements: any[];
  successfullSwitchMembership: object;
  actualQuote: object[];
  getActualQuote: () => void;
  getQuotations: (personaId, args, integrantes) => void;
  rightsChange: (idMembresiaSocio: string, idPersona: string) => IAction;
  refreshPartner: () => void;
  activeTab: string;
  membershipBlockedReactivacion: boolean;
  previousMaintenancesList: any[];
  directMaintenancesList: any[];
  directMembershipList: any[];
}

interface State {
  isOpen: boolean;
  data: object;
  selectedPerson: any;
  isOpenRights: boolean;
  isOpenConvenio: boolean;
  convenioAsociado: any;
  convenioAsociadoId: any;
  membershipChangeValidationMode: boolean;
  membershipChangeMessages: any[];
  membershipChangeCharges: any[];
  membershipChangeConditions: object;
  empresaId: string;
  modalBackToCotizacionIsOpen: boolean;
}

const search = (f, id, filters, integrantes) => {
  f(
    id,
    {
      ...filters,
      mesInicio: FIRST_MONTH,
      mesFin: LAST_MONTH,
      diaInicio: TODAY_NUMBER_MONTH
    },
    integrantes
  );
};

let filters: Filters = getEmptyFilters();

const Quotations = props => {
  const onChangeFilters = newFilters => {
    if (!!props.partner && props.partner.idMembresia && newFilters.club)
      search(
        props.getQuotations,
        props.partner.idPersona,
        {
          tipoPrecio: 1,
          clubAlternoId: newFilters.clubAlterno,
          ...newFilters,
          personaId: props.partner.idPersona,
          membresia: props.partner.idMembresia
        },
        []
      );

    filters = { ...newFilters, membresia: props.partner.idMembresia };
  };

  const handleSwitch = () => {
    props.toggle({
      clubId: filters.club,
      clubAlternoId: filters.clubAlternoId,
      mantenimientoId: filters.mantenimiento,
      membresiaId: filters.membresia,
      idPromocion: filters.promocion,
      idConvenio: filters.convenio
    });
  };

  return (
    <Container className="w-100 p-0 my-3">
      <Label>
        <b>Cotizacion actual:</b>
      </Label>
      {props.actualQuote && (
        <QuotationTable quotation={props.actualQuote} enableColumnEdition />
      )}
      <hr />
      <Label>
        <b>Cotizacion propuesta:</b>
      </Label>
      <QuotationNoMembership
        enableMemberEdition
        disableAgreements
        disablePromotions
        disableDiscounts
        disableReferredCode={true}
        disablePrices
        onChangeFilters={onChangeFilters}
        quotation={props.quotations}
        partner={props.partner}
      />

      <Col className="pl-0">
        <Button onClick={handleSwitch}>Aplicar cambios</Button>
      </Col>
    </Container>
  );
};

// Constante para la promoción Friends & Family
const FRIENDS_AND_FAMILY_PROMOTION_ID: any = 10006125;

class TabTransact extends React.Component<Props, State> {
  state = {
    isOpen: false,
    data: null,
    selectedPerson: null,
    isOpenRights: false,
    isOpenConvenio: false,
    convenioAsociadoId: null,
    convenioAsociado: null,
    membershipChangeValidationMode: false,
    membershipChangeMessages: [],
    membershipChangeCharges: [],
    membershipChangeConditions: null,
    empresaId: null,
    modalBackToCotizacionIsOpen: false
  };

  componentDidUpdate() {
    const { successfullSwitchMembership } = this.props;
    if (
      !isNil(successfullSwitchMembership) &&
      !isNil(successfullSwitchMembership[0])
    ) {
      if (!isNil(successfullSwitchMembership[0].data)) {
        const {
          idMembresiaSocio,
          idPublico,
          idClubBase
        } = successfullSwitchMembership[0].data;
        this.props.history.push(
          `/socio/venta-exitosa/${idMembresiaSocio}?idPublico=${idPublico}&idClub=${idClubBase}`
        );
      } else {
        successfullSwitchMembership.map(error => {
          if (error.tipo === "success") {
            this.props.history.push(
              `/productos/carrito/${this.props.partner.idPropietario}`
            );
          }
        });
      }
    }
  }

  // Verifica si la membresía tiene la promoción Friends & Family
  isFriendsAndFamilyPromotion = () => {
    return (
      !!this.props.partner &&
      this.props.partner.idPromocion == FRIENDS_AND_FAMILY_PROMOTION_ID
    );
  };

  toggleModal = (data?: object) => {
    this.setState({ isOpen: !this.state.isOpen, data: data });
  };

  toggleModalRights = () => {
    this.setState({ isOpenRights: !this.state.isOpenRights });
  };

  toggleModalConvenio = () => {
    this.setState({ isOpenConvenio: !this.state.isOpenConvenio });
  };

  setSelectedPerson = (person: any) => {
    this.setState({ selectedPerson: person });
  };

  handleRightsChange = () => {
    const { partner } = this.props;
    const { selectedPerson } = this.state;
    this.props.rightsChange(partner.idMembresiaSocio, selectedPerson.personaId);
    this.toggleModalRights();
  };

  handleAgreementAssociation = () => {
    const { convenioAsociadoId: convenioId, empresaId } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    infoNotification(UPDATE_CONVENIO_INFO);
    updateConvenioRequest(convenioId, idMembresiaSocio, empresaId)
      .then(() => {
        successNotification(UPDATE_CONVENIO_SUCCESS);
        this.setState({
          isOpenConvenio: false
        });
      })
      .catch(handleRequestError);
  };

  validateMembershipChange = (data?: object) => {
    this.setState({ data, membershipChangeConditions: data });

    const { partner } = this.props;
    switchMembershipValidationRequest(data, partner.idMembresiaSocio)
      .then(({ data }) => {
        const { resultado, mensajes, cargosAGenerar } = data;
        this.setState({
          isOpen: !this.state.isOpen,
          membershipChangeMessages: mensajes,
          membershipChangeCharges: cargosAGenerar
        });
      })
      .catch(handleRequestError);
  };

  executeMembershipChange = (sinPago: boolean) => {
    const { partner } = this.props;
    const { membershipChangeConditions } = this.state;

    switchMembershipRequest(
      { ...membershipChangeConditions, traspasoSinPago: !!sinPago },
      partner.idMembresiaSocio,
      "1",
      "false"
    )
      .then(({ data }) => {
        const { resultado } = data;
        const membresiaSocio = data.data || {};

        if (!!resultado) {
          this.closeAndClearMembershipChangeData();

          const { idMembresiaSocio, idPublico, idClubBase } = membresiaSocio;

          successNotification("El cambio de membresía se realizó exitoamente");

          //Si hubo un cambio de club, se va a la pantalla de venta exitosa de membresía socio, si no, se va al carrito para el pago
          if (partner.idClubBase != idClubBase) {
            this.props.history.push(
              `/socio/venta-exitosa/${idMembresiaSocio}?idPublico=${idPublico}&idClub=${idClubBase}`
            );
          } else {
            this.props.history.push(
              `/productos/carrito/${this.props.partner.idPropietario}`
            );
          }
        } else {
          errorNotification(
            "Ocurrió un error al ejecutar la petición de cambio de membresía"
          );
          this.closeAndClearMembershipChangeData();
        }
      })
      .catch(err => {
        errorNotification(
          "Ocurrió un error al ejecutar la petición de cambio de membresía"
        );
        this.closeAndClearMembershipChangeData();
      });
  };

  closeAndClearMembershipChangeData() {
    this.setState({
      isOpen: !this.state.isOpen,
      data: null,
      membershipChangeConditions: null,
      membershipChangeMessages: [],
      membershipChangeCharges: []
    });
  }

  cancelMembershipChange = () => {
    //Se cierra el modal y se limpian los datos
    this.closeAndClearMembershipChangeData();
  };

  render() {
    if (this.props.activeTab != "6") {
      return <></>;
    }

    const isIndividualOrFamiliarMembership =
      this.props.partner.idMembresia == 1 ||
      this.props.partner.idMembresia == 7;

    return (
      <TabPane className="my-2" tabId="6">
        {/* CAMBIO DE MEMBRESIA */}
        <ModalFrame
          title={"Confirmar cambio de condiciones"}
          isOpen={this.state.isOpen}
          toggle={this.toggleModal}
          size="lg"
        >
          <Container>
            <p>Mensajes:</p>
            <br />
            <NotificationsMessages
              messages={this.state.membershipChangeMessages || []}
            />

            <br />
            <br />
            <p>Cargos a generar:</p>
            <br />
            <ProcedureChargesMessages
              cargos={this.state.membershipChangeCharges || []}
            />

            {!(this.state.membershipChangeMessages || []).length && (
              <Row>
                <Col>
                  <br />
                  <p className={`text-center w-100`}>
                    ¿Desea realizar el cambio de membresía?
                  </p>
                </Col>
              </Row>
            )}
            <Row>
              <Col className="text-right">
                <Button
                  color="secondary"
                  onClick={this.cancelMembershipChange}
                  style={{ marginRight: "15px" }}
                >
                  Cancelar
                </Button>

                {!(this.state.membershipChangeMessages || []).length && (
                  <Button
                    color="primary"
                    onClick={() => {
                      this.executeMembershipChange(false);
                    }}
                    style={{ marginRight: "15px" }}
                  >
                    Aplicar
                  </Button>
                )}

                {!(this.state.membershipChangeMessages || []).length &&
                  !!this.state.membershipChangeCharges.find(
                    x => x.productoId == 14
                  ) && (
                    <Button
                      onClick={() => {
                        this.executeMembershipChange(true);
                      }}
                      style={{ marginRight: "15px" }}
                    >
                      Aplicar sin pago de traspaso
                    </Button>
                  )}
              </Col>
            </Row>
          </Container>
        </ModalFrame>

        {/* ASOCIACION DE CONVENIO */}
        <ModalFrame
          title={"¿Desea asociar el convenio?"}
          isOpen={this.state.isOpenConvenio}
          toggle={this.toggleModalConvenio}
        >
          <Container>
            <Row>
              <p className={`text-center w-100 mb-5`}>
                Se asociará el convenio {`${this.state.convenioAsociado}`} a la
                membresía socio. ¿Desea continuar?
              </p>
            </Row>
            <Row>
              <Col className="text-right">
                <Button
                  color="secondary"
                  onClick={this.toggleModalConvenio}
                  style={{ marginRight: "15px" }}
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  onClick={this.handleAgreementAssociation}
                >
                  Asociar
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFrame>

        <Container>
          {/* Cancelación de membresía socio */}
          {[PARTNER_MEMB_ACTIVE_STATUS, PARTNER_MEMB_INACTIVE_STATUS].includes(
            (this.props.partner || {}).estatusMembresia
          ) &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CANCEL_MEMBERSHIP
            ) && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Cancelación de membresía socio
                    </p>
                  </div>
                </div>
                <div>
                  <CancelMembership
                    partner={this.props.partner}
                    reload={this.props.refreshPartner}
                  />
                </div>
              </div>
            )}

          {/* Recotizacion de membresía socio */}
          {[
            PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS,
            PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
            PARTNER_MEMB_PENDIENTE_PAGO_STATUS,
            PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS
          ].includes((this.props.partner || {}).estatusMembresia) &&
            (this.props.partner || {}).tipoModalidadFlujoVenta == "VENTA" &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_RECOTIZAR_MEMBERSHIP
            ) && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Cancelar membresía socio
                    </p>
                  </div>
                </div>
                <div>
                  <RecotizarMembresia
                    partner={this.props.partner}
                    reload={() => {
                      this.props.history.push(
                        `/cotizaciones/prospecto/${this.props.partner.idPersona}`
                      );
                    }}
                  />
                </div>
              </div>
            )}

          {/* Inactivación de membresía socio */}
          {[
            PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS,
            PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
            PARTNER_MEMB_PENDIENTE_PAGO_STATUS,
            PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS
          ].includes((this.props.partner || {}).estatusMembresia) &&
            (this.props.partner || {}).tipoModalidadFlujoVenta ==
              "REACTIVACION" &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_INACTIVAR_MEMBERSHIP
            ) && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Inactivar membresía socio
                    </p>
                  </div>
                </div>
                <div>
                  <InactivarMembresia
                    partner={this.props.partner}
                    reload={() => {
                      if (!!this.props.refreshPartner) {
                        this.props.refreshPartner();
                      }
                    }}
                  />
                </div>
              </div>
            )}

          {/* Activación de membresia en estatus de preventa */}
          {[PARTNER_MEMB_ACTIVE_STATUS].includes(
            (this.props.partner || {}).estatusMembresia
          ) &&
            !!(this.props.partner || {}).preventa && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Membresía en preventa
                    </p>
                  </div>
                </div>
                <div>
                  <ActivatePresaleMembreship
                    partner={this.props.partner}
                    reload={this.props.refreshPartner}
                  />
                </div>
              </div>
            )}

          {/* Cambio a forma de pago mensual */}
          {[PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS].includes(
            (this.props.partner || {}).estatusMembresia
          ) && (
            <div className="mt-4">
              <div className="row mt-3 mb-3">
                <div className="col">
                  <p className={`${s.primaryTitle} w-100 m-0`}>
                    Cambio a forma de pago Mensual
                  </p>
                </div>
              </div>
              <div>
                <CambiarPagoMensual
                  partner={this.props.partner}
                  reload={this.props.refreshPartner}
                />
              </div>
            </div>
          )}

          {/* CAMBIO A MANTENIMIENTO PREVIO */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CHANGE_PREVIOUS_MAINTENANCE
            ) &&
            (this.props.previousMaintenancesList || []).length > 0 &&
            !this.isFriendsAndFamilyPromotion() && (
              <PreviousMaintenanceChange
                className="mt-4"
                partner={this.props.partner}
                refreshPartner={this.props.refreshPartner}
                previousMaintenancesList={this.props.previousMaintenancesList}
              />
            )}

          {/* CAMBIO A MANTENIMIENTO DIRECTO */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CHANGE_DIRECT_MAINTENANCE
            ) &&
            (this.props.directMaintenancesList || []).length > 0 &&
            !this.isFriendsAndFamilyPromotion() && (
              <DirectMaintenanceChange
                className="mt-4"
                partner={this.props.partner}
                refreshPartner={this.props.refreshPartner}
                directMaintenancesList={this.props.directMaintenancesList}
              />
            )}

          {/* CAMBIO A TIPO MEMBRESIA DIRECTO */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            !!isIndividualOrFamiliarMembership &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CHANGE_DIRECT_MEMBERSHIP_TYPE
            ) &&
            (this.props.directMembershipList || []).length > 0 &&
            !this.isFriendsAndFamilyPromotion() && (
              <DirectMembershipChange
                className="mt-4"
                partner={this.props.partner}
                refreshPartner={this.props.refreshPartner}
                directMembershipList={this.props.directMembershipList}
              />
            )}

          {/* CESION DE DERECHOS */}
          {(((this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CESION
            )) ||
            ((this.props.partner || {}).estatusMembresia !=
              PARTNER_MEMB_ACTIVE_STATUS &&
              userHasPermission(
                permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CESION_INACTIVE_MEMB
              ))) && (
            <CesionDerechos
              className="mt-4"
              partner={this.props.partner}
              rightsChange={this.props.rightsChange}
              refreshPartner={this.props.refreshPartner}
            />
          )}

          {/* CAMBIO DE TITULAR */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_CHANGE_TITULAR
            ) && (
              <CambioTitular
                className="mt-4"
                partner={this.props.partner}
                refreshPartner={this.props.refreshPartner}
              />
            )}

          {/* ASOCIACION DE CONVENIO */}
          {userHasPermission(
            permissionCodes.PARTNER_MEMBERSHIP_ASSIGN_AGGREMENT_PERMISSION
          ) &&
            (this.props.partner || {}).estatusMembresia ==
              PARTNER_MEMB_ACTIVE_STATUS &&
            !(this.props.partner || {}).preventa &&
            !this.isFriendsAndFamilyPromotion() && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Asociación de convenio
                    </p>
                  </div>
                </div>
                <Row className="row mt-3 mb-3">
                  <Col>
                    <Label className={s.label}>Convenio:</Label>
                    <Typeahead
                      label={"Convenio"}
                      name="Convenio"
                      type="select"
                      id="Convenio"
                      promptText={"Convenio"}
                      bsSize={"sm"}
                      emptyLabel={"Sin coincidencias"}
                      options={
                        this.props.agreements
                          ? this.props.agreements.map(agreement => ({
                              id: `${agreement.convenioId}-${agreement.empresaId}`,
                              label: agreement.empresa
                            }))
                          : []
                      }
                      onChange={sel =>
                        this.setState({
                          convenioAsociadoId:
                            sel.length > 0 ? sel[0]["id"].split("-")[0] : null,
                          convenioAsociado:
                            sel.length > 0 ? sel[0]["label"] : null,
                          empresaId:
                            sel.length > 0 ? sel[0]["id"].split("-")[1] : null
                        })
                      }
                    />
                  </Col>
                  <Col className="mt-4">
                    <Button
                      size="sm"
                      className={`float-right btn-block`}
                      onClick={this.toggleModalConvenio}
                      disabled={
                        this.state.convenioAsociadoId === "" ||
                        this.state.convenioAsociadoId === null
                      }
                    >
                      Asociar convenio
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

          {/* CAMBIO DE CLUB, EXCLUSIVAMENTE */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_TRAM_TRANSFER_CLUB
            ) &&
            !(this.props.partner || {}).preventa && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Traspaso de club conservando el plan actual
                    </p>
                  </div>
                </div>
                <div style={{ marginLeft: "-15px", marginRight: "-15px" }}>
                  <TransferClubMembership
                    partner={this.props.partner}
                    clubs={this.props.clubs}
                    redirect={url => {
                      location.pathname = url;
                    }}
                  />
                </div>
              </div>
            )}

          {/* CAMBIO DE MEMBRESIA */}
          {(this.props.partner || {}).estatusMembresia ==
            PARTNER_MEMB_ACTIVE_STATUS &&
            !(this.props.partner || {}).preventa && (
              <div className="mt-4">
                <div className="row mt-3 mb-3">
                  <div className="col">
                    <p className={`${s.primaryTitle} w-100 m-0`}>
                      Cambio de membresía o traspaso
                    </p>
                  </div>
                </div>
                <Row className="p-0 m-0">
                  <Quotations
                    {...this.props}
                    toggle={this.validateMembershipChange}
                  />
                </Row>
              </div>
            )}
        </Container>
      </TabPane>
    );
  }
}

export default TabTransact;
